import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { BehaviorSubject } from "rxjs";
import { finalize } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class InquiryService {
  private _isLoading$ = new BehaviorSubject<boolean>(false);
  private _isLoadingTable$ = new BehaviorSubject<boolean>(false);
  private _badgeCount$ = new BehaviorSubject<number>(0);
  private _assetsCount$ = new BehaviorSubject<number>(0);
  private _blockAICount$ = new BehaviorSubject<number>(0);
  private _claimCount$ = new BehaviorSubject<number>(0);
  private _allowListCount$ = new BehaviorSubject<number>(0);
  private _aiContentRemovalCount$ = new BehaviorSubject<number>(0);
  private _copyRightDownListCount$ = new BehaviorSubject<number>(0);
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  get isLoading$() {
    return this._isLoading$.asObservable();
  }

  get isLoadingTable$() {
    return this._isLoadingTable$.asObservable();
  }

  get badgeCount$() {
    return this._badgeCount$.asObservable();
  }

  get assetsCount$() {
    return this._assetsCount$.asObservable();
  }
  get blockAICount$() {
    return this._blockAICount$.asObservable();
  }
  get claimCount$() {
    return this._claimCount$.asObservable();
  }

  get allowListCount$() {
    return this._allowListCount$.asObservable();
  }

  get aiContentRemovalCount$() {
    return this._aiContentRemovalCount$.asObservable();
  }
  get copyRightDownListCount$() {
    return this._copyRightDownListCount$.asObservable();
  }

  changeStatus(requestBody) {
    return this.http.put(
      `${this.apiUrl}/browse/approved/rejected`,
      requestBody
    );
  }

  getInquiryList(params) {
    this._isLoadingTable$.next(true);
    return this.http.post(`${this.apiUrl}/inquiry-list`, params).pipe(
      finalize(() => {
        this._isLoadingTable$.next(false);
      })
    );
  }

  setStatus(id, body) {
    this._isLoading$.next(true);
    return this.http
      .put(`${this.apiUrl}/inquiry-list/change-status/${id}`, body)
      .pipe(
        finalize(() => {
          this._isLoading$.next(false);
          this.getBadgeCount();
        })
      );
  }

  getBadgeCount() {
    this._isLoading$.next(true);
    return this.http
      .get(`${this.apiUrl}/inquiry-list/badge/count`)
      .pipe(
        finalize(() => {
          this._isLoading$.next(false);
        })
      )
      .subscribe((response: any) => {
        this._badgeCount$.next(response.result);
      });
  }

  getAssetPendingReview(params) {
    this._isLoading$.next(true);
    return this.http
      .post(`${this.apiUrl}/CID/asset/original/badge/count`, params)
      .pipe(
        finalize(() => {
          this._isLoading$.next(false);
        })
      )
      .subscribe((response: any) => {
        this._assetsCount$.next(response.result);
      });
  }

  getBlockAIPendingReview() {
    this._isLoading$.next(true);
    return this.http
      .post(`${this.apiUrl}/block/ai/count`, {status:1})
      .pipe(
        finalize(() => {
          this._isLoading$.next(false);
        })
      )
      .subscribe((response: any) => {
        this._blockAICount$.next(response.result);
      });
  }

  getClaiming() {
    this._isLoading$.next(true);
    return this.http
      .post(`${this.apiUrl}/manual/claim/count`, {
        search: "",
        status: "1,6",
        rights_holder: "",
      })
      .pipe(
        finalize(() => {
          this._isLoading$.next(false);
        })
      )
      .subscribe((response: any) => {
        this._claimCount$.next(response.result);
      });
  }

  getAllowList() {
    this._isLoading$.next(true);
    return this.http
      .post(`${this.apiUrl}/allow/list/request/count`, {
        status: "1"
      })
      .pipe(
        finalize(() => {
          this._isLoading$.next(false);
        })
      )
      .subscribe((response: any) => {
        this._allowListCount$.next(response.result);
      });
  }

  getAiContentRemovalList() {
    this._isLoading$.next(true);
    return this.http
      .post(`${this.apiUrl}/ai/content/removal/count`, {
        status: "1"
      })
      .pipe(
        finalize(() => {
          this._isLoading$.next(false);
        })
      )       
      .subscribe((response: any) => {
        this._aiContentRemovalCount$.next(response.result);
      });
  }

  getRightDownList() {
    this._isLoading$.next(true);
    return this.http
      .post(`${this.apiUrl}/copyright/takedown/count`, {
        status: "1"
      })
      .pipe(
        finalize(() => {
          this._isLoading$.next(false);
        })
      )
      .subscribe((response: any) => {
        this._copyRightDownListCount$.next(response.result);
      });
  }
}
